module.exports = __webpack_public_path__ + "static/img/female_doctor.b4e6732.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/doctors/female_doctor.jpg
// module id = wcCq
// module chunks = 7